import Vue from "vue";
import formatDistanceToNow from "date-fns/formatDistanceToNow";

const months = [
  "Jan",
  "Feb",
  "Mar",
  "Apr",
  "May",
  "Jun",
  "Jul",
  "Aug",
  "Sept",
  "Oct",
  "Nov",
  "Dec"
];

const dateFilter = value => {
  return formatDate(value);
};
const dateFilterWithHour = value => {
  if (!value || value == "") {
    return "";
  }

  return formatDate(value, true);
};

function formatDate(inputDate, showHour = false) {
  inputDate = inputDate.replace(/-/g, "/");
  const date = new Date(inputDate);
  const year = date.getFullYear();
  const month = date.getMonth();
  const day = date.getDate();
  const hour = date.getHours();
  const minutes = date.getMinutes();
  let formattedDate;
  if (showHour) {
    let amPm = "AM";
    if (hour > 12) {
      amPm = "PM";
    }
    formattedDate =
      months[month] +
      ", " +
      day +
      " " +
      year +
      " " +
      hour +
      ":" +
      minutes +
      " " +
      amPm;
  } else {
    formattedDate = months[month] + ", " + day + " " + year;
  }
  return formattedDate;
}

function timeAgo(inputDate) {
  inputDate = inputDate.replace(/-/g, "/");
  const date = new Date(inputDate);
  const year = date.getFullYear();
  const month = date.getMonth();
  const day = date.getDate();
  const hour = date.getHours();
  const minutes = date.getMinutes();

  return formatDistanceToNow(new Date(year, month, day, hour, minutes), {
    addSuffix: true
  });
}

Vue.filter("timeAgo", timeAgo);

//MM - d - yyyy
Vue.filter("date", dateFilter);

//MM - d - yyyy H:m
Vue.filter("dateWithHours", dateFilterWithHour);
